import { Injectable } from '@angular/core'
import { TCurrentUserResponse } from '@app/types/TCurrentUser'
import { BehaviorSubject } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class CurrentUserService {
    private _user$ = new BehaviorSubject<Partial<TCurrentUserResponse>>({})

    public getCurrentUser() {
        return this._user$.value
    }

    public getCurrentUser$() {
        return this._user$.asObservable()
    }

    public setCurrentUser(user: TCurrentUserResponse) {
        this._user$.next(user)
    }

    public clearCurrentUser() {
        this._user$.next({})
    }

    public setStorage(value: Record<string, any>) {
        Object.entries(value).forEach(([key, value]) => {
            localStorage.setItem(key, value)
        })
    }

    public clearStorage() {
        localStorage.clear()
    }
}
